import React from "react";
import * as Styles from "./max-width-container.styles";

export const MaxWidthContainer = ({ children }) => (
  <Styles.Outer>
    <Styles.Inner>{children}</Styles.Inner>
  </Styles.Outer>
);
